import { connect } from 'react-redux';
import { VOD, WATCH, TRENDING } from 'app-source/routes/types';
import { actions, selectors } from 'app-webtech-core';
import { redirect } from 'redux-first-router';
import { Menu as MenuComponent } from '../components/Menu';
import { sectionSelect } from '../utils/sectionSelect';

const mapStateToProps = (state) => ({
  marketingRegion: selectors.playbackSession.properties(state).marketingRegion,
  isMenuOpen: selectors.layout.properties(state).isMenuOpen,
  locationType: selectors.location.properties(state).type,
});

const mapDispatchToProps = (dispatch) => ({
  redirectToWatch: () => sectionSelect(dispatch, WATCH),
  redirectToVod: () => sectionSelect(dispatch, VOD),
  redirectToTrending: () => dispatch(redirect({ type: TRENDING })),
  openMenu: () => dispatch(actions.layout.openMenu()),
  closeMenu: () => dispatch(actions.layout.closeMenu()),
});

const mergeProps = ({ locationType, ...stateProps }, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  redirectToWatch: () => {
    if (locationType !== 'PAGE_WATCH_CHANNEL') {
      dispatchProps.redirectToWatch();
    }
  },
});

export const Menu = connect(mapStateToProps, mapDispatchToProps, mergeProps)(MenuComponent);
